import { getAlerts } from '../../api/alerts/getAlerts';
import { Alert, AlertsDTO } from '../../types/alerts/alerts';
import { GenericState } from '../../types/apiModule';
import { LinksPage, PageInfo } from '../../types/pagination/pagination';
import createApiModule from '../createApiModule';

interface AlertsModule extends GenericState<unknown> {
  data: AlertsDTO;
}

const initialState: AlertsModule = {
  errors: null,
  loading: false,
  data: {
    data: [] as Alert[],
    links: {} as LinksPage,
    meta: {} as PageInfo,
  },
};

const alertsModule = createApiModule({
  name: 'alerts',
  apiMethod: getAlerts,
  initialState,
  parse: (response) => response,
  onSuccess: () => {},
  onError: () => ({
    message: 'No hemos podido cargar las alertas',
  }),
  onValidationError: () => ({
    message: 'No hemos podido cargar las alertas',
  }),
});

export const {
  start: listAlerts,
  success: listAlertsOk,
  error: listAlertsKo,
  reset: resetAlerts,
} = alertsModule.slice.actions;

export const { sagas } = alertsModule;

export default alertsModule;
